module.exports = __webpack_public_path__ + "img/cate-icon-3.4f161eb0.png";